import CloseIcon from '@mui/icons-material/Close';
import { Box, IconButton } from '@mui/material';
import { styled } from '@mui/system';

export const DialogContentWrapper = styled('div')({
  padding: '20px'
});

export const CloseDialogButton = styled((props: any) => (
  <IconButton aria-label="close" sx={{ position: 'absolute', right: 8, top: 8 }} {...props}>
    <CloseIcon />
  </IconButton>
))(() => ({}));

export const DialogSubtitle = styled('div')({
  fontSize: '15px',
  cursor: 'default',
  padding: '10px 0'
});

export const UploadButtonWrapper = styled(Box)({
  margin: '25px 0 15px 0'
});

export const SelectBox = styled('div')({
  fontSize: '16px',
  textDecoration: 'underline',
  color: '#0675DD'
});
